import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/Login.vue')
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/Register.vue')
    },
    {
      path: '/verify',
      name: 'verify',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/Verify.vue')
    },
    {
      path: '/resetemailsent',
      name: 'resetemailsent',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/ResetEmailSent.vue')
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/ResetPassword.vue')
    },
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Home.vue'),
      children: [
        {
          path: '/',
          name: 'overview',
          component: () => import('./views/Overview.vue')
        },
        {
          path: '/dashboard/:projectId',
          name: 'dashboard',
          component: () => import('./views/Dashboard.vue')
        },
        {
          path: '/service/:projectId',
          name: 'service',
          component: () => import('./views/ServiceDetail.vue')
        },
        {
          path: '/details',
          name: 'details',
          component: () => import('./views/Detail.vue')
        },
        {
          path: '/credential/:projectId',
          name: 'credential',
          component: () => import('./views/Credential.vue')
        },
        {
          path: '/classification/:projectId',
          name: 'classification',
          component: () => import('./views/Classification.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/Profile.vue')
        },
        {
          path: '/profile/password',
          name: 'password',
          component: () => import('./views/Password.vue')
        },
        {
          path: '/settings/:projectId',
          name: 'settings',
          component: () => import('./views/Settings.vue')
        },
        {
          path: '/tokendebugger',
          name: 'tokendebugger',
          component: () => import('./views/TokenDebugger.vue')
        }
      ]
    },
    {
      path: '/privacypolicy',
      name: 'privacypolicy',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/PrivacyPolicy.vue')
    },
    {
      path: '/terms',
      name: 'terms',
      meta: {
        requiresAuth: false
      },
      component: () => import('./views/TermAndCondition.vue')
    }
  ]
})

router.beforeEach((to, from, next) => {
  gtag('config', 'UA-154851174-1', { page_path: to.path })
  if (to.matched.some(record => record.meta.requiresAuth !== false)) {
    const isAuthenticated = store.getters['user/isAuthenticate']
    // Is this OK for bypass for token-debugger page
    if (isAuthenticated || to.path === '/tokendebugger') {
      next()
    } else {
      next({ name: 'login', query: { redirect: to.path } })
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  // TODO Reconsider this condition again
  if (from.name) {
    // window.onePalette.emitEvent('routing', {
    //   action: 'routing',
    //   target: null,
    //   linkTo: to.name,
    //   label: 'console',
    //   value: null,
    //   amount: null
    // })
  }
})

export default router
